module.exports = __webpack_public_path__ + "img/2196b71e5930b4c56cf412aa260dc3e8.png";